import React from "react";
import Input from "../../../../widget/common/form/Input";
import TextArea from "../../../../widget/common/form/Textarea";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { ARFContextImport } from "../../../../provider/chats/chats/ARF/ARFContextProvider";

export const ARFNameField = () => {
  const { nameField, fieldsValid, submitForm, handleOnChange } =
    ARFContextImport();

  return (
    <Input
      type="text"
      name="name"
      label="name"
      handleOnChange={handleOnChange}
      value={nameField}
      validate={true}
      error={submitForm ? !fieldsValid.name : false}
    />
  );
};

export const ARFDateField = () => {
  const { dateField, fieldsValid, submitForm, handleOnChange } =
    ARFContextImport();

  return (
    <Input
      type="datepicker"
      name="date"
      label="date"
      handleOnChange={handleOnChange}
      value={dateField}
      validate={true}
      error={submitForm ? !fieldsValid.date : false}
    />
  );
};

export const ARFTimeField = () => {
  const { timeField, fieldsValid, submitForm, handleOnChange } =
    ARFContextImport();

  return (
    <Input
      type="timepicker"
      name="time"
      label="time"
      handleOnChange={handleOnChange}
      value={timeField}
      validate={true}
      error={submitForm ? !fieldsValid.time : false}
    />
  );
};

export const ARFNoPeopleField = () => {
  const { noPeopleField, fieldsValid, submitForm, handleOnChange } =
    ARFContextImport();

  return (
    <Input
      type="number"
      name="number_of_people"
      label="number_of_people"
      handleOnChange={handleOnChange}
      value={noPeopleField}
      validate={true}
      error={submitForm ? !fieldsValid.name : false}
    />
  );
};

export const ARFSubjectField = () => {
  const { subjectField, fieldsValid, submitForm, handleOnChange } =
    ARFContextImport();

  return (
    <Input
      type="text"
      name="subject"
      label="subject"
      handleOnChange={handleOnChange}
      value={subjectField}
      validate={true}
      error={submitForm ? !fieldsValid.subject : false}
    />
  );
};

export const ARFMessageField = () => {
  const { messageField, fieldsValid, submitForm, handleOnChange, maxWords } =
    ARFContextImport();

  return (
    <TextArea
      name="message"
      rowSize={6}
      placeHolder={AppTranslation.text("type_here_max_200_chars")}
      maxWords={maxWords}
      handleOnChange={handleOnChange}
      value={messageField}
      validate={true}
      error={submitForm ? !fieldsValid.message : false}
    />
  );
};
